module.exports = __webpack_public_path__ + "static/media/avatar-14.27c06db4.svg";